export default "__VITE_ASSET__473c3750__"